export const SUPPORTED_LANGUAGES = ['fa', 'en'] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export type DateDisplayPreset = 'date' | 'dateTime' | 'time';

export const DEFAULT_LOCALE = {
  language: 'fa' as AppLanguage,
  timezone: 'Asia/Tehran'
} as const;

export const LOCALE_DATE_SETTINGS: Record<
  AppLanguage,
  {
    intlLocale: string;
    calendar: 'jalali' | 'gregorian';
    formats: Record<DateDisplayPreset, string>;
    persianDigits: boolean;
  }
> = {
  fa: {
    intlLocale: 'fa-IR',
    calendar: 'jalali',
    formats: {
      date: 'YYYY/MM/DD',
      time: 'HH:mm',
      dateTime: 'HH:mm YYYY/MM/DD'
    },
    persianDigits: true
  },
  en: {
    intlLocale: 'en-US',
    calendar: 'gregorian',
    formats: {
      date: 'YYYY-MM-DD',
      time: 'HH:mm',
      dateTime: 'HH:mm YYYY-MM-DD'
    },
    persianDigits: false
  }
};

export const isSupportedLanguage = (
  language: string | undefined
): language is AppLanguage =>
  SUPPORTED_LANGUAGES.includes(language as AppLanguage);
